var map = {
	"./ContributionGraph": 9309,
	"./ContributionGraph.jsx": 9309,
	"./HelloWorld": 927,
	"./HelloWorld.jsx": 927,
	"./ModuleSelect": 3535,
	"./ModuleSelect.jsx": 3535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6900;